import apiClient from '../../shared/auth/services'

/**
 * モバイルパスワードリセットサービス
 * パスワードリセットトークンの有効性確認とパスワード更新機能を提供
 */
export const mobileResetPasswordService = {
  /**
   * リセットトークンの有効性確認
   * パスワードリセット用のトークンが有効かどうかを確認
   * @param {string} resetToken - リセットトークン
   * @returns {Promise<Object>} トークン有効性確認結果
   */
  async checkResetPassword(resetToken) {
    const response = await apiClient.post('/appResetPassword', {
      resetToken: resetToken
    })
    return response.data
  },

  /**
   * パスワード更新
   * リセットトークンを使用してパスワードを更新
   * @param {string} resetToken - リセットトークン
   * @param {string} loginPassword - 新しいログインパスワード
   * @returns {Promise<Object>} パスワード更新結果
   */
  async updatePixLabelPassword(resetToken, loginPassword) {
    const response = await apiClient.post('/updatePixLabelPassword', {
      resetToken: resetToken,
      loginPassword: loginPassword
    })
    return response.data
  },
}

export default mobileResetPasswordService
